export default {
  props: {
    file: {
      type: Object,
      required: true
    }
  }
}
